var _rect, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 98,
    viewBox: "0 0 292 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -67.8693,
    y: -67.8693,
    width: 427.739,
    height: 233.739
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(33.93px)",
      clipPath: "url(#bgblur_0_5953_7124_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 67.8693,
    y: 98,
    width: 98,
    height: 292,
    rx: 30,
    transform: "rotate(-90 0 98)",
    fill: "#D9D9D9",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5953_7124",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 33,
    width: 231,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260.403 33H30.8125V64.1429H260.403V33Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5953_7124)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5953_7124",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 32,
    width: 227,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M258.556 32.8398H32.6094V63.7645H258.556V32.8398Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5953_7124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.3438 56.7049V40.3086H80.8992C82.6474 40.3086 84.177 40.7237 85.4881 41.7614C86.7992 42.7992 87.2363 44.0445 87.2363 45.4973C87.2363 47.1577 86.5806 48.403 85.4881 49.2331C84.3956 50.0634 82.6474 50.8935 80.6808 50.8935H77.6215V56.7049H74.3438ZM77.8399 47.9879H80.6808C81.5549 47.9879 82.2104 47.7803 82.6474 47.3652C83.0844 46.9501 83.3029 46.3275 83.3029 45.7048C83.3029 45.0822 83.0844 44.4595 82.6474 44.0445C82.2104 43.4218 81.5549 43.2143 80.6808 43.2143H77.6215V47.9879H77.8399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0156 48.611C94.0156 46.328 94.8897 44.2525 96.6377 42.5921C98.3859 40.9318 100.571 40.1016 103.193 40.1016C105.597 40.1016 107.782 40.9318 109.749 42.5921C111.497 44.2525 112.59 46.328 112.371 48.611C112.371 50.894 111.497 52.9696 109.749 54.6299C108.001 56.2903 105.815 57.1204 103.193 57.1204C100.79 57.1204 98.6045 56.2903 96.6377 54.6299C94.6711 52.9696 94.0156 50.894 94.0156 48.611ZM108.875 48.611C108.875 46.9506 108.438 45.7053 107.345 44.6676C106.252 43.6299 104.941 43.2148 103.193 43.2148C101.664 43.2148 100.353 43.6299 99.26 44.6676C98.1675 45.7053 97.7304 46.9506 97.7304 48.611C97.7304 50.2713 98.1675 51.5167 99.26 52.5544C100.353 53.5921 101.664 54.0072 103.193 54.0072C104.723 54.0072 106.034 53.5921 107.127 52.5544C108.219 51.3092 108.875 50.0639 108.875 48.611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.672 56.7049V40.3086H124.168V53.7992H131.816V56.9125H120.672V56.7049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.046 40.3086L145.146 50.2708V56.7049H141.65V50.2708L135.75 40.3086H139.683L143.617 46.7426L147.331 40.3086H151.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.72 56.7049V41.5539H157.383V40.3086H171.368V41.5539H165.031V56.9125H163.72V56.7049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.002 56.7049H191.472L185.572 49.4407H181.202V56.9125H179.891V40.3086H185.791C187.32 40.3086 188.631 40.7237 189.505 41.5539C190.379 42.3841 191.035 43.4218 191.035 44.8747C191.035 46.1199 190.598 46.9501 189.942 47.7803C189.287 48.6104 188.194 49.0256 187.102 49.2331L193.002 56.7049ZM181.202 41.5539V48.1954H185.572C186.883 48.1954 187.757 47.9879 188.413 47.3652C189.068 46.7426 189.505 45.9124 189.505 44.8747C189.505 43.8369 189.068 43.0067 188.413 42.3841C187.757 41.7614 186.883 41.5539 185.572 41.5539H181.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.54 56.7055L211.792 52.762H202.615L200.867 56.7055H199.555L206.985 40.1016H207.641L215.07 56.7055H213.54ZM207.421 42.3846L203.489 51.7243H211.574L207.421 42.3846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.812 56.7049V40.3086H228.619C231.46 40.3086 233.864 41.1388 235.612 42.5916C237.36 44.0445 238.234 46.1199 238.234 48.403C238.234 50.8935 237.36 52.7615 235.612 54.4219C233.864 56.0822 231.678 56.7049 228.619 56.7049H223.812ZM225.341 55.6671H228.837C231.241 55.6671 233.208 55.0446 234.738 53.5917C236.268 52.3463 236.922 50.4784 236.922 48.6104C236.922 46.535 236.268 44.8747 234.738 43.6294C233.208 42.3841 231.46 41.7614 228.837 41.7614H225.341V55.6671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.41 56.7049V40.3086H258.335V41.5539H248.94V47.3652H256.369V48.6104H248.94V55.6671H258.773V56.9125H247.41V56.7049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4685 44.669L59.4869 51.3106C60.1426 51.7255 61.0167 51.3106 61.0167 50.4803V41.1407C61.0167 40.7255 60.798 40.518 60.361 40.3105L47.25 33.0463C47.0315 32.8387 46.5945 32.8387 46.3759 33.0463L33.2649 40.3105C32.8279 40.3105 32.6094 40.7255 32.6094 41.1407V44.4614L46.3759 36.9897C46.813 36.7821 47.0315 36.7821 47.4685 36.9897L57.0833 42.1784C57.5203 42.3859 57.7389 42.801 57.7389 43.0086V46.3293L47.4685 40.7255C47.0315 40.518 46.813 40.518 46.3759 40.7255L33.2649 47.9897C32.8279 48.1973 32.6094 48.6123 32.6094 48.8199V55.4614C32.6094 55.8766 32.8279 56.0841 33.0464 56.2917L36.1056 57.9521V50.8954C36.1056 50.4803 36.3242 50.2727 36.7612 50.0652L46.3759 44.8765C46.8492 44.5499 47.0315 44.4614 47.4685 44.669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4684 59.6139C47.0314 59.8213 46.8129 59.8213 46.3758 59.6139L39.8203 56.0856V59.4064C39.8203 59.8213 40.0388 60.0289 40.2574 60.2365L46.3758 63.5572C46.8129 63.7648 47.0314 63.7648 47.4684 63.5572L61.235 56.0856L58.1757 54.4252C57.7386 54.2176 57.5202 54.2176 57.0832 54.4252L47.4684 59.6139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4688 55.8808L53.1502 52.7676C53.5872 52.5601 53.5872 52.1449 53.1502 51.9374L47.4688 48.6166C47.0317 48.409 46.8132 48.409 46.3762 48.6166L40.4762 51.7298C40.0392 51.9374 40.0392 52.3525 40.4762 52.5601L46.1577 55.6733C46.5947 56.0884 47.0317 56.0884 47.4688 55.8808Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5953_7124_clip_path",
    transform: "translate(67.8693 67.8693)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 98,
    width: 98,
    height: 292,
    rx: 30,
    transform: "rotate(-90 0 98)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4);
export default __webpack_public_path__ + "static/media/Group (4).18e110528d3ba3f3fa4607d8c9bcce80.svg";
export { ForwardRef as ReactComponent };